<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="classesPopup()"
          >新增班次</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="classesName" label="班次名称">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.classesName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="起始时间"> </el-table-column>
      <el-table-column prop="endTime" label="结束时间"> </el-table-column>
      <el-table-column prop="duration" label="时长">
        <template slot-scope="scope">
          {{ scope.row.duration }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="classesPopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="classesDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 班次表单 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="classesAddFormVisible" center>
      <el-form
        :model="classesAddForm"
        :size="$store.state.formSize"
        :rules="classesAddFormRules"
        ref="refClassesAddForm"
        label-width="100px"
      >
        <el-form-item label="班次名称：" prop="classesName">
          <el-input
            v-model="classesAddForm.classesName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="起始时间：" prop="startHoursVal">
          <el-select
            v-model="classesAddForm.startHoursVal"
            style="width:50%"
            placeholder="小时"
          >
            <el-option
              v-for="item in startTimeHourList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="classesAddForm.startMinutesVal"
            style="width:50%"
            placeholder="分钟"
          >
            <el-option
              v-for="item in startTimeMinuteList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结束时间：" prop="endHoursVal">
          <el-select
            v-model="classesAddForm.endHoursVal"
            style="width:50%"
            placeholder="小时"
          >
            <el-option
              v-for="item in endTimeHourList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="classesAddForm.endMintusVal"
            style="width:50%"
            placeholder="分钟"
          >
            <el-option
              v-for="item in endTimeMinuteList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时长：">
          <el-input :value="duration" disabled autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="classesAddForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="classesAddFormVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawer" size="40%" :with-header="false">
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawer = false"></i>
          <span>班次详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">班次名称</td>
            <td>{{ detailDate.classesName }}</td>
            <td class="list-item">班次时长</td>
            <td>{{ detailDate.duration }}</td>
          </tr>
          <tr>
            <td class="list-item">起始时间</td>
            <td>{{ detailDate.startTime }}</td>
            <td class="list-item">结束时间</td>
            <td>{{ detailDate.endTime }}</td>
          </tr>
          <tr>
            <td class="list-item">备注</td>
            <td>{{ detailDate.remark }}</td>
            <td class="list-item"></td>
            <td></td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getClassesList,
  putClassesAdd,
  getClassesDetail,
  postClassesEdit,
  deleteClassesDel,
  delClassesList
} from '@/api/classes'

const __isNumber = val => typeof val === 'number'

const __createTime = (h, m, tom = false) => {
  const day = tom ? 2 : 1

  return moment([2020, 1, day])
    .add(h, 'hours')
    .add(m, 'minutes')
}

const __calcDiffTime = (s, e) => {
  const diffMintus = e.diff(s, 'minutes')
  const diffHours = e.diff(s, 'hours')
  const restMintus = diffMintus - diffHours * 60

  return { hours: Math.abs(diffHours), minutes: Math.abs(restMintus) }
}

const __createTimeFormat = (h, m) => {
  h = h >= 10 ? h : `0${h}`
  m = m >= 10 ? m : `0${m}`
  return `${h}:${m}`
}

const createFormVals = () => ({
  classesName: '',
  startHoursVal: '',
  startMinutesVal: '',
  endHoursVal: '',
  endMintusVal: '',
  remark: '',
  get startTime() {
    return __createTimeFormat(this.startHoursVal, this.startMinutesVal)
  },
  get endTime() {
    return __createTimeFormat(this.endHoursVal, this.endMintusVal)
  }
})

export default {
  data() {
    const curryCheckOvertime = formName => (rule, value, callback) => {
      const __val = this.classesAddForm[formName]

      if (!__isNumber(value)) {
        callback(new Error('请输入小时'))
      } else if (!__isNumber(__val)) {
        callback(new Error('请输入分钟'))
      } else {
        callback()
      }
    }

    return {
      currentID: null,
      isDisabled: false,
      classesAddFormVisible: false,
      drawer: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      startTimeHourList: [],
      startTimeMinuteList: [],
      endTimeHourList: [],
      endTimeMinuteList: [],
      tableData: [],
      detailDate: [],
      classesAddForm: createFormVals(),
      classesAddFormRules: {
        classesName: [
          { required: true, message: '请输入班次名称', trigger: 'blur' }
        ],
        startHoursVal: [
          {
            required: true,
            validator: curryCheckOvertime('startMinutesVal'),
            trigger: 'blur'
          }
        ],
        endHoursVal: [
          {
            required: true,
            validator: curryCheckOvertime('endMintusVal'),
            trigger: 'blur'
          }
        ]
      },
      loading: true,
      selectionID: []
    }
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑班次' : '新增班次'
    },
    times() {
      return {
        sH: this.classesAddForm.startHoursVal,
        sM: this.classesAddForm.startMinutesVal,
        eH: this.classesAddForm.endHoursVal,
        eM: this.classesAddForm.endMintusVal
      }
    },
    // 计算时长
    duration() {
      const { sH, sM, eH, eM } = this.times

      if (
        __isNumber(sH) &&
        __isNumber(sM) &&
        __isNumber(eH) &&
        __isNumber(eM)
      ) {
        const sTime = __createTime(sH, sM)
        const eTime = __createTime(eH, eM, eH < sH || (eH === sH && eM < sM))
        const { hours, minutes } = __calcDiffTime(sTime, eTime)

        if (minutes === 0) {
          return `${hours}小时`
        }

        return `${hours}小时${minutes}分钟`
      }

      return ''
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.classesSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delClassesList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getClassesListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getClassesListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getClassesListData()
    },
    // 删除班次
    classesDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteClassesDel({
            id: id
          }).then(res => {
            if (res.status === 1) {
              this.$message.success('删除班次成功')
              this.getClassesListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增班次
    classesSubmit() {
      this.$refs.refClassesAddForm.validate(valid => {
        if (!valid) return false
        const changeClasses = this.currentID ? postClassesEdit : putClassesAdd
        changeClasses({
          classesName: this.classesAddForm.classesName,
          duration: this.duration,
          endTime: this.classesAddForm.endTime,
          startTime: this.classesAddForm.startTime,
          remark: this.classesAddForm.remark,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑班次成功') : this.$message.success('新增班次成功')
            this.classesAddFormVisible = false
            this.getClassesListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 修改班次
    classesPopup(id) {
      const isAdd = !id
      this.classesAddFormVisible = true

      if (isAdd) {
        this.$set(this, 'classesAddForm', createFormVals())
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getClassesDetail({ id }).then(res => {
          if (res.status === 1) {
            this.classesAddForm.classesName = res.data.classesName
            this.classesAddForm.remark = res.data.remark

            // e.g. '12:03'.split(':') -> ['12', '03']
            const [sH, sM] = res.data.startTime.split(':')
            const [eH, eM] = res.data.endTime.split(':')

            this.classesAddForm.startHoursVal = parseInt(sH)
            this.classesAddForm.startMinutesVal = parseInt(sM)
            this.classesAddForm.endHoursVal = parseInt(eH)
            this.classesAddForm.endMintusVal = parseInt(eM)
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getClassesListData()
    },
    // 刷新数据表格
    refresh() {
      this.getClassesListData()
      this.$message.success('数据刷新成功')
    },
    // 班次详情
    detailShow(id) {
      this.drawer = true
      getClassesDetail({
        id: id
      }).then(res => {
        console.log(res.data)
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取班次列表
    getClassesListData() {
      this.loading = true
      getClassesList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    }
  },
  mounted() {
    this.getClassesListData()
    for (let i = 0; i < 24; i++) {
      let label = i
      if (i < 10) {
        label = '0' + i
      }
      this.startTimeHourList.push({ label: label, value: i })
      this.endTimeHourList.push({ label: label, value: i })
    }
    for (let i = 0; i < 60; i += 5) {
      let label = i
      if (i < 10) {
        label = '0' + i
      }
      this.startTimeMinuteList.push({ label: label, value: i })
      this.endTimeMinuteList.push({ label: label, value: i })
    }
  }
}
</script>
